import nprogress from 'nprogress';
import router from '@/router';

nprogress.configure({ showSpinner: true, trickleSpeed: 200 });

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.showProgressBar))
        nprogress.start();
    next();
});

router.afterEach((to, from) => {
    if (to.matched.some(record => record.meta.showProgressBar))
        nprogress.done();
});

export default {
    install(Vue, options) {
        Vue.prototype.$nprogress = nprogress;
    },
};
